// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + {"23":"liveboardTS'","332":"chat'"}[chunkId] + "." + {"23":"ad3e268c","332":"2fa53169"}[chunkId] + ".chunk.css");